import EmblaCarousel from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";
import Fade from "embla-carousel-fade";
import { addPrevNextButtonsClickHandlers } from "javascripts/embla/arrows";
import { addDotButtonsAndClickHandlers } from "javascripts/embla/dots";
import { updateSelectedSnapDisplay } from "javascripts/embla/indexes";
import { addThumbButtonsClickHandlers, addToggleThumbButtonsActive } from "javascripts/embla/thumbnails";

const defaultOptions = { loop: true };
const initializeEmbla = (baseClass, { arrows = true, fade = true, autoplay = false, dots = false, indexes = false, thumbnails = false, emblaOptions = {} } = {}) => {
  const emblaElements = document.querySelectorAll(`.${baseClass}`);
  const emblaInstances = [];

  emblaElements.forEach((emblaElement) => {
    const container = emblaElement.querySelector(".c-embla__container");
    if (!container) return;
    if (container.dataset.emblaInitialized === "true") return;
    container.dataset.emblaInitialized = "true";

    const prevButton = emblaElement.querySelector(".c-embla-arrows__link--prev");
    const nextButton = emblaElement.querySelector(".c-embla-arrows__link--next");
    const dot = emblaElement.querySelector(".c-embla-dots");
    const snapDisplayNode = emblaElement.querySelector(".c-embla-indexes");
    const thumbContainer = emblaElement.querySelector(".c-embla-thumbnails");

    const options = { ...defaultOptions, ...emblaOptions };
    const plugins = [];
    if (fade) {
      plugins.push(Fade());
    }
    if (autoplay) {
      plugins.push(Autoplay({ stopOnInteraction: false }));
    }

    const emblaApi = EmblaCarousel(container, options, plugins);
    emblaInstances.push({ emblaApi, emblaElement });

    const autoplayPlugin = autoplay ? emblaApi?.plugins()?.autoplay : null;

    if (autoplayPlugin) {
      const options = {
        rootMargin: "0% 0%",
        threshold: 0.6,
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            autoplayPlugin.play();
          } else {
            autoplayPlugin.stop();
          }
        });
      }, options);
      observer.observe(emblaElement);
      emblaApi.on("destroy", () => observer.disconnect());
    }

    const resetToClick = () => {
      autoplayPlugin?.reset();
    };

    if (arrows) {
      const removeArrowClickHandlers = addPrevNextButtonsClickHandlers(emblaApi, prevButton, nextButton, resetToClick);
      emblaApi.on("destroy", removeArrowClickHandlers);
    }

    if (dots) {
      const removeDotClickHandlers = addDotButtonsAndClickHandlers(emblaApi, dot);
      emblaApi.on("destroy", removeDotClickHandlers);
    }

    if (indexes) {
      updateSelectedSnapDisplay(emblaApi, snapDisplayNode);
    }

    if (thumbnails && thumbContainer) {
      const emblaApiThumb = EmblaCarousel(thumbContainer, {
        containScroll: "keepSnaps",
        dragFree: true,
      });

      const removeThumbButtonsClickHandlers = addThumbButtonsClickHandlers(emblaApi, emblaApiThumb);
      const removeToggleThumbButtonsActive = addToggleThumbButtonsActive(emblaApi, emblaApiThumb);

      emblaApi.on("destroy", removeThumbButtonsClickHandlers).on("destroy", removeToggleThumbButtonsActive);
      emblaApiThumb.on("destroy", removeThumbButtonsClickHandlers).on("destroy", removeToggleThumbButtonsActive);
    }
  });

  return emblaInstances;
};

export { initializeEmbla as embla };
